import SubscribeForm from '@/components/feature/SubscribeForm';
import { siteInfo } from '@/mocks/feed';

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="border-t border-background-200/70 bg-background-100/40">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="mb-3 flex items-center gap-2">
              <span className="h-3 w-[3px] rounded-full bg-primary-500" />
              <span className="font-label text-xs tracking-[0.3em] text-primary-300 uppercase">Subscribe</span>
            </div>
            <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              熬不动的时候，让整理替你值夜
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              订阅之后，每天早上八点会收到一封简短邮件：夜里出现过哪些话题、哪几条发生了反转、哪几条经核查后应当作废。
              不推送、不打扰，只是一份安静的整理。
            </p>

            <ul className="mt-8 space-y-3">
              {[
                '按午夜、凌晨、后半夜分段汇总，一眼看清推进顺序',
                '标注"待核"条目，避免把转述当成原始材料',
                '可直接回复邮件补充线索方向，值夜编辑会看',
              ].map((line) => (
                <li key={line} className="flex items-start gap-3 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-400" />
                  {line}
                </li>
              ))}
            </ul>

            <p className="mt-8 text-xs leading-relaxed text-foreground-500">
              也可以直接写信给我们：{siteInfo.email}
            </p>
          </div>

          <div className="lg:col-span-7">
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}